import { get } from "lodash";

import { SHADOW } from "@treelab/panda";

import { IChartFormValue } from "../types/form-type";
import { ITableData, IWrokspaceData } from "../types/table-type";
import { ChartType } from "../types/global-type";
import { ITooltipFormatterParams } from "../types/echarts-type";

import BasicBarChart from "./BasicBarChart";
import CalculationDataByChart from "./CalculationDataByChart";

import { getBasicDataset, getBarTooltipDom, getTooltipPosition, getXAxisData } from "../utils/option_main";
import { getGridWidth } from "../utils/option_secondary";

import { SERIES_AXIS_LABEL_MIN_WIDTH } from "../constants/chart";

/**
 * 柱状图用 class 可用于实例化
 */
class BarChart extends BasicBarChart {
  public getDataset(
    formValue: IChartFormValue,
    tableData: ITableData,
    workspaceData: IWrokspaceData,
    calculation: CalculationDataByChart
  ) {
    const dataset = getBasicDataset(formValue, tableData, workspaceData, ChartType.BASIC_BAR, this.calculation);
    if (Array.isArray(dataset)) {
      const transformList = dataset
        .filter((item) => !!get(item, "transform"))
        .map((item) => get(item, "transform.config.value"));
      this.stackTypeList = transformList;
    } else {
      this.stackTypeList = [];
    }
    return dataset;
  }

  public getTooltip() {
    const canvasWidth = this.getCanvasWidth();
    const tooltip = {
      trigger: "item",
      backgroundColor: "rgba(255, 255, 255, 0.98)",
      borderWidth: 0,
      padding: [10, 12],
      extraCssText: SHADOW.overlay1,
      formatter: (param: ITooltipFormatterParams, ticket: string) => {
        const newParam = this.convertTooltipParams(param);
        const dom = getBarTooltipDom(
          newParam,
          canvasWidth,
          this.formValue.chartType,
          this.formatValue,
          this.calculation.isGroup
        );
        return dom;
      },
      axisPointer: {
        type: "shadow",
      },
      position: getTooltipPosition,
    };
    return tooltip;
  }

  public getSeries(formValue: IChartFormValue, tableData: ITableData, workspaceData: IWrokspaceData) {
    const { isShowLabel, chartType, isShowYAxis } = formValue;
    let label: any = { show: false };
    if (isShowLabel) {
      const data = getXAxisData(get(this.datasetObj, "[0].source"));
      const xAxisWidth = getGridWidth(this.getCanvasWidth(), this.isExpand, chartType, !!isShowYAxis, true);
      if (xAxisWidth > data.length * SERIES_AXIS_LABEL_MIN_WIDTH) {
        label = {
          position: "top",
          show: true,
          formatter: (params: { data: any[] }) => {
            const value = params.data[1];
            return this.formatValue(value);
          },
          color: "inherit",
          textBorderColor: "#fff",
          textBorderWidth: 1,
        };
      }
    }
    const basicSeries = {
      type: "bar",
      itemStyle: {
        borderRadius: 4,
      },
      label: label,
      encode: { x: 0, y: 1 },
      animationDuration: 600,
    };
    if (!this.stackTypeList.length) {
      return [
        {
          ...basicSeries,
        },
      ];
    }
    const seriesList = this.stackTypeList.map((item, index) => ({
      ...basicSeries,
      name: item,
      barGap: "10%",
      barCategoryGap: "32.8%",
      datasetIndex: index + 1,
    }));
    return seriesList;
  }
}

export default BarChart;
